import Crud from '../views/Sub_Grupo/Crud'
import Entity from '../views/Sub_Grupo/Add'

let routes = {
    path: '/sub_grupos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/sub_grupos/add',
            name: 'NewSubGrupo',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Sub Grupo',
                breadcrumb: [
                    {
                        text: 'Sub Grupos',
                        to: '/sub_grupos',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/sub_grupos/edit/:id?',
            name: 'EditSubGrupo',
            component: Entity,
            meta: {
                pageTitle: 'Editar Sub Grupo',
                breadcrumb: [
                    {
                        text: 'Sub Grupos',
                        to: '/sub_grupos',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/sub_grupos',
            name: 'list-sub_grupos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Sub Grupos',
                breadcrumb: [
                    {
                        text: 'Sub Grupos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
